import { Injectable } from '@angular/core';
import { Observable ,  of } from 'rxjs';
import { CategoryList, AdultCategoryList } from './categories';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn:"root"
})

export class CategoryService {
    isAdult = environment.cinema === 2;
    categoryList;

    constructor() {
        this.categoryList = this.isAdult ? AdultCategoryList : CategoryList;
    }

    getCategoryList(): Observable<any[]> {
        return of(this.categoryList);
    }
    /*
    ** 可选的列表
    */
    getCategoryListSelectable(): Observable<any[]> {
        return of(this.categoryList.filter(p=>{
            return p.selectable;
        }))
    }
    getCategoryByUrl(url): Observable<any[]> {
        return of(this.categoryList.filter(item => {
            return item.filterKey?item.filterKey.indexOf(url)>-1: item.link === '/' + url;
        }));
    }

    getCategoryByCId(cid) {
        if (!cid) {
            return undefined;
        }
        let res = this.categoryList.filter(item => item.cid === cid.split(',').slice(0, 3).join(','));
        if (res.length > 0) {
            return res[0];
        }

        res = this.categoryList.filter(item => item.cid === cid);
        if (res.length > 0) {
            return res[0];
        }
        return undefined;
    }

    getCategoryByTitle(title): string {
        const res = this.categoryList.filter(item => item.title === title);
        if (res.length > 0) {
            return res[0].slug;
        }
        return undefined;
    }

    getCategoryBySlug(slug) {
        if (slug === 'movies') {
            slug = 'movie';
        }
        if (slug === 'tv-series') {
            slug = 'drama';
        }
  
        const res = this.categoryList.filter(item => item.slug === slug);
        if (res.length > 0) {
            return res[0];
        }
        return undefined;
    }

    getSecondLevelCid(cid) {
        if (!cid) {
            return undefined;
        }
        const r = cid.split(',');
        if ((r.length) < 4) {
            return cid;
        }
        return (r.slice(0, 3)).join(',');
    }

    getCategoryLink(cid) {
     
        let result;

        const cidArray = cid.split(',');
        if (cidArray.length > 3) {
            result = { url: '/list', params: cid };
            return result;
        }
        const category = this.getCategoryByCId(cid);
        if(category !=null)
        {
            result = { url: category.link, params: undefined };
            if (['sport', 'chinese', 'games'].indexOf(category.slug) > -1) {
                result = { url: '/list', params: category.cid };
            }
            else if(category.tagFilter)
            {
                result = { url: '/list', params: category.slug };

            }
        }
        else
        {
            result = {url:'/list',params:{cid:"top"}};
        }
    
        

        return result;
    }
}
